import request from "@/utils/request";

export function listAll(params) {
	return request({
		url: '/app/maternity/insurance/list-all',
		method: 'get',
		params
	})
}

export function save(data) {
	return request({
		url: '/app/maternity/insurance/save',
		method: 'post',
		data
	})
}

export function getDetail(id) {
	return request({
		url: '/app/maternity/insurance/get?id=' + id,
		method: 'get'
	})
}


export function submit(data) {
	return request({
		url: '/app/maternity/insurance/submit',
		method: 'post',
		data
	})
}
